import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Student } from './students/student';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpError } from './errors';
import { SemsoEncryptionModule } from './encryption/encryption.module';

@Injectable()
export class StudentsService {
  private studentsRetrievalErrorBase = new Subject<Boolean>();
  public studentsRetrievalError$ = this.studentsRetrievalErrorBase.asObservable();

  private startedStudentsRetrievalErrorBase = new Subject<Boolean>();
  public startedStudentsRetrievalError$ = this.startedStudentsRetrievalErrorBase.asObservable();

  private startCoreSubjectErrorBase = new Subject<Boolean>();
  public startCoreSubjectError$ = this.startCoreSubjectErrorBase.asObservable();

  constructor(
    private http: HttpClient,
    private encryption: SemsoEncryptionModule) { }

  public getAllStudentsByClass(klas: string): any {
    var result = this.http.post<Student[]>('/klas', { naam: klas }).pipe(catchError(error => {
      this.studentsRetrievalErrorBase.next(false);
      throw new HttpError(`Error retrieving students by class ${klas}`);
    }));

    return result;
  }

  public getAllStudentsWithStartedExaminations(): any {
    var result = this.http.get<Student[]>('/crebos')
      .pipe(catchError(error => {
        this.startedStudentsRetrievalErrorBase.next(false);
        throw new HttpError(`Error retrieving students with started pvb's`);
      }));

    return result;
  }

  public startCoreTaskByStudentIdAndCoreTaskId(studentIdEncrypted: string, coreTaskId: string, creboId: string): any {
    var studentId = this.encryption.decrypt(studentIdEncrypted);

    return this.http.post<number>(`/studenten/${studentId}/${creboId}/kerntaken/${coreTaskId}/start`, {})
      .pipe(catchError(error => {
        this.startCoreSubjectErrorBase.next(false);
        throw new HttpError(`Error starting core task for student: ${studentId}`);
      }));
  }

  public startMetOvernemenCoreTaskByStudentIdAndCoreTaskId(studentIdEncrypted: string, coreTaskId: string, creboId: string): any {
    var studentId = this.encryption.decrypt(studentIdEncrypted);

    return this.http.post<number>(`/studenten/${studentId}/${creboId}/kerntaken/${coreTaskId}/startmetovernemen`, {})
      .pipe(catchError(error => {
        this.startCoreSubjectErrorBase.next(false);
        throw new HttpError(`Error starting core task for student: ${studentId}`);
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/students.service.ts